import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';
import { Reservation } from './reservation.model';

/**
 * @class DashboardData
 */
export class DashboardData extends TranslatableModel {

    setReservations(value) {

        return {
            created: this.getTodayTomorrowMapper(value.created),
            arrival: this.getTodayTomorrowMapper(value.arrival),
            departure: this.getTodayTomorrowMapper(value.departure),
            inHouse: this.getTodayTomorrowMapper(value.inHouse),
        };
    }

    setTodayActivity(data) {

        return this.mapActivity(data);
    }

    mapActivity(data) {

        data.cancellations.reservations = this.getReservationsMapper(data.cancellations.reservations);
        data.sales.reservations = this.getReservationsMapper(data.sales.reservations);

        return data;
    }

    getTodayTomorrowMapper(value) {

        return Object.assign(value, {
            today: this.getReservationsMapper(value.today),
            tomorrow: this.getReservationsMapper(value.tomorrow),
        });
    }

    getReservationsMapper(value = []) {

        return value.map(attributes => attributes instanceof Reservation ? attributes : new Reservation(attributes));
    }
}

AccessorsMutatorsDecorator(
    'activeBookings',
    'arrivals',
    'departures',
    'reservations',
    'todayActivity',
    'occupancy',
    'outlook',
)(DashboardData);



// WEBPACK FOOTER //
// ./src/pms-api/models/dashboard-data.model.js